import { useLpkRunContext } from './lpk-run-context';
import { NutrientSection } from './NutrientSection';

export function PhosphorusSection() {
  const { selectedNutrients } = useLpkRunContext();

  return (
    selectedNutrients.phosphorus && (
      <NutrientSection nutrient="phosphorus" label="P" />
    )
  );
}
